import React, { useRef, useState, useEffect } from "react";
import { Play, Pause } from "lucide-react";

const fmt = (s) => {
    if (!isFinite(s)) return "00:00";
    const m = Math.floor(s / 60);
    const r = Math.floor(s % 60);
    return `${String(m).padStart(2, "0")}:${String(r).padStart(2, "0")}`;
};

export const AudioPlayer = ({ src, title }) => {
    const audioRef = useRef(null);
    const [playing, setPlaying] = useState(false);
    const [progress, setProgress] = useState(0);
    const [duration, setDuration] = useState(0);
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        const audio = audioRef.current;
        if (!audio) return undefined;
        const onTime = () => {
            setCurrent(audio.currentTime);
            setProgress(audio.duration ? (audio.currentTime / audio.duration) * 100 : 0);
        };
        const onLoad = () => setDuration(audio.duration || 0);
        const onEnd = () => setPlaying(false);
        audio.addEventListener("timeupdate", onTime);
        audio.addEventListener("loadedmetadata", onLoad);
        audio.addEventListener("ended", onEnd);
        return () => {
            audio.removeEventListener("timeupdate", onTime);
            audio.removeEventListener("loadedmetadata", onLoad);
            audio.removeEventListener("ended", onEnd);
        };
    }, [src]);

    const toggle = () => {
        const a = audioRef.current;
        if (!a) return;
        if (playing) { a.pause(); setPlaying(false); }
        else { a.play(); setPlaying(true); }
    };

    const seek = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const pct = (e.clientX - rect.left) / rect.width;
        const a = audioRef.current;
        if (a && a.duration) a.currentTime = pct * a.duration;
    };

    return (
        <div className="audio-player" data-testid="audio-player">
            <audio ref={audioRef} src={src} preload="metadata" />
            <button data-testid="audio-play-toggle" className="play-btn" onClick={toggle} aria-label="Play / Pause">
                {playing ? <Pause size={18} fill="currentColor" /> : <Play size={18} fill="currentColor" />}
            </button>
            <div className="flex-1 flex flex-col gap-2">
                {title && <div className="text-xs uppercase tracking-[0.2em] text-white/70 truncate">{title}</div>}
                <div className="progress" onClick={seek} data-testid="audio-progress">
                    <div className="progress-fill" style={{ width: `${progress}%` }} />
                </div>
            </div>
            <div className="time hidden sm:block">{fmt(current)} / {fmt(duration)}</div>
        </div>
    );
};
